import { useEffect, useState } from 'react';
import api from '../api/client.js';

// ============================================================
//  Imagen que vive detras de la sesion.
//
//  El token JWT viaja en Authorization. Un <img src="/api/..."> no manda
//  cabeceras: el GET da 401 y se ve rota. Se baja con el mismo cliente
//  axios de la app (sesion, proxy, URL del API) y se muestra como blob.
// ============================================================

export default function ImagenProtegida({ ruta, preview, alt = '', ...props }) {
  const [url, setUrl] = useState(preview || null);
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    if (preview) {
      setUrl(preview);
      setFallo(false);
      return undefined;
    }
    let vivo = true;
    let objeto;
    setUrl(null);
    setFallo(false);

    api.get(ruta, { responseType: 'blob' })
      .then((r) => {
        const blob = r.data;
        const tipo = String(blob?.type || '');
        if (!blob || blob.size < 24 || tipo.includes('json') || tipo.includes('html')) {
          throw new Error('no disponible');
        }
        if (!vivo) return;
        objeto = URL.createObjectURL(blob);
        setUrl(objeto);
      })
      .catch(() => { if (vivo) setFallo(true); });

    return () => {
      vivo = false;
      if (objeto) URL.revokeObjectURL(objeto);
    };
  }, [ruta, preview]);

  if (fallo) {
    return (
      <div {...props} style={{
        ...props.style,
        display: 'grid', placeItems: 'center',
        background: 'var(--surface-2)', color: 'var(--text-muted)', fontSize: 10,
      }}>
        sin foto
      </div>
    );
  }

  if (!url) {
    return <div {...props} style={{ ...props.style, background: 'var(--surface-2)' }} />;
  }

  return <img src={url} alt={alt} {...props} />;
}
